import type { ChatBodyMessagesItemRole } from './chatBodyMessagesItemRole';

export type ChatBodyMessagesItem = {
  /** 메시지 내용 */
  content: string;
  /** 메시지 역할 */
  role: ChatBodyMessagesItemRole;
};
